import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import { useAuthStore } from "./stores/auth";
import { useProjectSummaryStore } from "./stores/project";
import { useProjectStore } from "./stores/project";

// Bootstrap & Icons
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";

// Peimar and AGS Themes
import "@/assets/styles/themes.scss";

// i18n (Composition API Mode)
import { createI18n } from "vue-i18n";
import en from "@/locals/en.json";
import it from "@/locals/it.json";
import es from "@/locals/es.json";
import fr from "@/locals/fr.json";
import de from "@/locals/de.json";

// Google Maps Configuration
declare global {
  interface Window {
    GOOGLE_MAPS_API_KEY: string;
  }
}

// Initialize Google Maps API from centralized loader
import { loadGoogleMapsAPI } from "@/utils/googleMapsLoader";

const initializeGoogleMapsAPI = async () => {
  try {
    await loadGoogleMapsAPI();
    console.log("Google Maps API initialized successfully");
  } catch (error) {
    console.error("Failed to initialize Google Maps API:", error);
  }
};

const i18n = createI18n({
  legacy: false, // ✅ Use Composition API instead of Legacy
  locale: "it",
  messages: {
    en,
    it,
    es,
    fr,
    de,
  },
});

const app = createApp(App);
const pinia = createPinia();
app.use(pinia).use(router).use(i18n);

// Initialize stores
const authStore = useAuthStore(pinia);
const projectSummaryStore = useProjectSummaryStore(pinia);
const projectStore = useProjectStore(pinia);

// Initialize from storage
authStore.initializeFromStorage();
projectSummaryStore.initializeFromStorage();
projectStore.initializeFromStorage();

// Initialize Google Maps API only if user is authenticated
if (authStore.isAuthenticated) {
  initializeGoogleMapsAPI();
}

app.mount("#app");
